import React from "react";

export const getDisplayName = WrappedComponent => {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

export const injectProps = injectedProps => WrappedComponent => {
    return props => <WrappedComponent {...injectedProps} {...props}/>;
};